var _rect, _rect2, _g, _rect3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1019_6196)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1019_6196",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 25,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.8418,
    y: 2.18457,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1019_6196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3418 17.1846H15.3418L14.7668 13.9596C15.1001 13.7929 15.3626 13.5512 15.5543 13.2346C15.746 12.9179 15.8418 12.5679 15.8418 12.1846C15.8418 11.6346 15.646 11.1637 15.2543 10.7721C14.8626 10.3804 14.3918 10.1846 13.8418 10.1846C13.2918 10.1846 12.821 10.3804 12.4293 10.7721C12.0376 11.1637 11.8418 11.6346 11.8418 12.1846C11.8418 12.5679 11.9376 12.9179 12.1293 13.2346C12.321 13.5512 12.5835 13.7929 12.9168 13.9596L12.3418 17.1846ZM13.8418 24.1846C11.5251 23.6012 9.61263 22.2721 8.1043 20.1971C6.59596 18.1221 5.8418 15.8179 5.8418 13.2846V7.18457L13.8418 4.18457L21.8418 7.18457V13.2846C21.8418 15.8179 21.0876 18.1221 19.5793 20.1971C18.071 22.2721 16.1585 23.6012 13.8418 24.1846ZM13.8418 22.0846C15.5751 21.5346 17.0085 20.4346 18.1418 18.7846C19.2751 17.1346 19.8418 15.3012 19.8418 13.2846V8.55957L13.8418 6.30957L7.8418 8.55957V13.2846C7.8418 15.3012 8.40846 17.1346 9.5418 18.7846C10.6751 20.4346 12.1085 21.5346 13.8418 22.0846Z",
    fill: "#1C1B1F"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#FFDF0A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1019_6196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.8d8c55cf335fe4c6a854b22b2b2fbc77.svg";
export { ForwardRef as ReactComponent };